import { IGoogleAddress } from 'interfaces/googleAddress.interface';
import { TgoogleAddressDispatchReducer } from './googleAddress.reducer';
import * as GoogleAddressTypes from './googleAddress.types';

export async function setGoogleAddressAction({
  dispatch,
  formKey,
  field,
  value,
}: {
  dispatch: React.Dispatch<TgoogleAddressDispatchReducer>;
  formKey: string;
  field: string;
  value: string;
}) {
  dispatch({
    type: GoogleAddressTypes.SET_GOOGLE_ADDRESS,
    payload: {
      formKey,
      field,
      value,
    },
  });
}

export async function autoSetGoogleAddressAction({
  dispatch,
  values,
}: {
  dispatch: React.Dispatch<TgoogleAddressDispatchReducer>;
  values: IGoogleAddress;
}) {
  dispatch({
    type: GoogleAddressTypes.AUTO_SET_GOOGLE_ADDRESS,
    payload: {
      values,
    },
  });
}

export async function resetGoogleAddressAction({
  dispatch,
  formKey,
  values,
}: {
  dispatch: React.Dispatch<TgoogleAddressDispatchReducer>;
  formKey: string;
  values: IGoogleAddress | null;
}) {
  dispatch({
    type: GoogleAddressTypes.RESET_GOOGLE_ADDRESS,
    payload: {
      formKey,
      values,
    },
  });
}
